module.exports = __webpack_public_path__ + "img/is_bankasi_logo.4d8f42a3.svg";